import store from '../../../core/store';

export const listCompanyTags = () => {
  return store.dispatch({
    action: 'table.company_tags/LIST',
    method: 'GET',
    endpoint: '/company-tags',
  });
};

export const createCompanyTag = (data) => {
  return store.dispatch({
    action: 'table.company_tags/CREATE',
    method: 'POST',
    endpoint: '/company-tags',
    data,
  });
};

export const updateCompanyTag = (tagId, data) => {
  return store.dispatch({
    action: 'table.company_tags/UPDATE',
    method: 'PUT',
    endpoint: `/company-tags/${tagId}`,
    data,
  });
};

export const deleteCompanyTag = (tagId) => {
  return store.dispatch({
    action: 'table.company_tags/DELETE',
    method: 'DELETE',
    endpoint: `/company-tags/${tagId}`,
  });
};
